import React, { useEffect, useState  , useMemo} from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setDecalarationActionData,
  setPerformanceAction,
  setPerformanceDeleteAction,
  setSelectedPerformer,
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import "../../../StyleSheet/MainComponent/Performance/Performance.scss";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

import Delete from "../../AppComponent/Popup/Delete";

import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ViewSymblos from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-23.svg";

function PerformanceTable(props) {
  const {
    performanceData,
    setEditPayload,
    setDeleteID,
    typeOfParent,
    EMpHeaderSelected,
    typeOfperformance,
    setEmpHeadersSele,
    setDeletepopup,
    setPerformances,
  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState("");
  const [pageSize, setPageSize] = useState(20);
  // const [DeletePopup, setDeletepopup] = useState(false);
  const [delted, setdeleteid] = useState("");

  const MakeCreate = true;

  const HandleParentChnages = (e) => {
    setdtPageindex(1);
    if (e != null) {
      setPerformances(e.value);
      setEmpHeadersSele(e);
    }
  };

  const performanceDataTotalCount = useSelector(
    (state) => state.performanceTypeCall.Total_Count
  );
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        // const payload = {
        //   search: e,
        //   page_size: dtpagesize,
        //   page: 1,
        //   parent_type: typeOfperformance,
        // };
        // dispatch(setPerformanceAction(payload));
        setsearch(e);

      }, 500),
    []
  );


   console.log(typeOfperformance , 
    "typeOfperformance"
   );
  // -----Search------------------------
  function tochange(e) {
    // setsearch(e);

    setdtPageindex(1);
    props.searchchanges(e);
    debouncedSearch(e);

    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesize,
    //     page: 1,
    //     parent_type: typeOfperformance,
    //   };
    //   dispatch(setPerformanceAction(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //     parent_type: typeOfperformance,
    //   };
    //   dispatch(setPerformanceAction(payload));
    // }
  }


  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  useEffect(() => {
    const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
      parent_type: typeOfperformance,
    };
    dispatch(setPerformanceAction(payload));
  }, [typeOfperformance, dtpageindex , search]);

  
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
  // const HandelDelete = () => {
  //   if (DeleteId != undefined) {
  //     console.log(currentPage, "sdsd");
  //     const payload = {
  //       DeleteId: DeleteId,
  //       currentPage: currentPage,
  //       mode: "all",
  //     };
  //     dispatch(SetRoleDeleteCalActions(payload, setDeletepopup(false)));
  //   }
  // };

  const HandleSubmits = () => {
    if (delted != undefined) {
      const payload = {
        DeleteID: delted,
        currentPage: dtpageindex,
        parent_type: typeOfperformance,
      };
      dispatch(setPerformanceDeleteAction(payload, setDeletepopup(false)));
    }
  };

  const columns = [
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return <div>{row.row.original.grading_name}</div>;
      },
    },
    {
      Header: "Skill Assessment Type",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.parent_type == "Tech" ? (
              <div>{"Technical"}</div>
            ) : (
              <div>{"Soft Services"}</div>
            )}
          </>
        );
      },
    },

    {
      Header: "Total Points",
      accessor: "",
      Cell: (row) => {
        return <div>{row.row.original.total_points}</div>;
      },
    },
    {
      Header: "Points",
      accessor: "",
      Cell: (row) => {
        return <div>{row.row.original.points}</div>;
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <div>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </div>
        );
      },
    },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className=" btn Status"
                onClick={(e) => {
                  setEditPayload(row.row.original);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
                  {/* <i
                    class="fa-solid fa-pen"
                    style={{ fontSize: "14px", paddingRight: "3px", paddingBottom:"3px" }}
                  ></i> */}
                   <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={() => {
                  setDeleteID(row.row.original.id);
                  setdeleteid(row.row.original.id);
                  setDeletepopup(true);
                  props.dtpageindex(dtpageindex);
                }}
              >
                <span className="OuterActionSpan">
                  {/* <i
                    class="fa-regular fa-trash-can"
                    style={{
                      fontSize: "15px",
                      paddingRight: "3px",
                      paddingBottom: "3px",
                    }}
                  ></i> */}
                  <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>

                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
              <button
                type="button"
                class="btn Status"
                onClick={() => {
                  // setDeleteID(row.row.original.id);
                  dispatch(setSelectedPerformer(row.row.original));
                  navigate("/performancetype");
                }}
              >
              
<span className="OuterActionSpan">
<span  className="EditImages">
                    <img src={ViewSymblos}/>
                  </span>

                  <span className="ActionsList"> View </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ];

  const ViewFunctions = (data) => {
    console.log(data, "mulamulamula");
    // dispatch(setSelectedPerformer(data.data));
    //               navigate("/performancetype");
  };
  return (
    <>
      <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
        <ReactTable
          data={performanceData}
          columns={columns}
          totalItems={performanceDataTotalCount}
          currentPage={currentPage}
          onChange={tochange}
          setCurrentPage={setCurrentPage}
          pagesize={pagesize}
          onPrevious={handlePrevious}
          onNextpage={handleNext}
          GotoEnteredPage={GotoEnteredPage}
      dtpagesize={pageSize}
          dtpageindex={dtpageindex}
          pageindex={pageindex}
          datacount={performanceDataTotalCount}
          MakeCreate={false}
          ViewParts={(e) => {
            ViewFunctions(e);
          }}
          typeOfParent={typeOfParent}
          HandleParentChnages={HandleParentChnages}
          typeOfParentlist={true}
          EMpHeaderSelected={EMpHeaderSelected}
          Filter={true}
          OldEmployeFilters={false}
          Superviorsfilter={false}
          nostatusFilter={true}
        />
      </div>
    </>
  );
}

export default PerformanceTable;
